export const BrandName = 'koodo'

export const PHONE_NUMBER_OPTIONS = {
  CHOOSE_A_NEW_NUMBER: 'CHOOSE_A_NEW_NUMBER',
  TRANSFER_NUMBER: 'TRANSFER_NUMBER'
}

export const PLAN_DURATION = {
  SLOT_30: 30,
  SLOT_90: 90,
  SLOT_365: 365
}

export const PAYMENT_OPTIONS = {
  CREDIT_CARD: 'creditCard',
  VOUCHER: 'voucher'
}

export const CARD_VALIDATION_ERRORS = {
  UNAUTHORIZED: 'unauthorized',
  FAILED: 'failed'
}

export const PAGE_NUMBER = {
  ACCOUNT_SETUP: 1,
  SIM_SELECTION: 2,
  CHOOSE_NUMBER: 3,
  PLAN_SELECTION: 4,
  PAYMENT: 5,
  PLAN_PRESELECTED_PAYMENT: 4
}

export const LANGUAGES_CODE = {
  EN: 'en',
  FR: 'fr'
}

export const LANGUAGES = [
  { value: LANGUAGES_CODE.EN, label: 'English' },
  { value: LANGUAGES_CODE.FR, label: 'Français' }
]

export const PORT_ORDER_AUTH_TYPE = {
  ACCOUNT: 'account',
  SERIAL_NUMBER: 'serial',
  PIN: 'PIN',
  NONE: 'none'
}

export const VALID_AVS_CODES = ['D', 'M', 'X', 'Y', 'A', 'B', 'W', 'Z', 'P', 'S']

export const CONSUMER_SIM_OPTIONS = {
  HAVE_SIM: 'haveSIM',
  NEW_SIM: 'newSIM'
}

export const SIM_OPTIONS = {
  P_SIM: 'pSIM',
  E_SIM: 'eSIM',
  H_SIM: 'haveSIM'
}

export const SIM_COST = {
  pSIM: 0,
  eSIM: 5
}

export const CONSUMER_ESIM_OPTIONS = {
  NEW_E_SIM: 'eSim',
  NEW_SIM_CARD: 'pSIM'
}

export const FR_TAX_TYPE_LABELS = {
  HST: 'TVH',
  QST: 'TVQ',
  GST: 'TPS',
  PST: 'TVP'
}

export const EN_TAX_TYPE_LABELS = {
  TVH: 'HST',
  TVQ: 'QST',
  TPS: 'GST',
  TVP: 'PST'
}

// Email validation rules:
// - Local part (before @): must start with a letter or digit; may contain letters, digits, +, _, -;
//   dots are allowed as separators but not at the start, end, or consecutively (e.g. "a.b" ok, ".a" or "a..b" not ok)
// - Must contain exactly one @
// - Domain (after @): one or more labels separated by dots; each label must start and end with a letter,
//   with letters or hyphens in between (no digits in domain labels, no leading/trailing hyphens)
// - TLD (final label): letters only, no digits
// Valid examples:   user@example.com, first.last+tag@my-domain.org
// Invalid examples: .user@example.com, user@.com, user@exam_ple.com, user@123.com
// ⚠️  Note: domain labels reject digits entirely, so addresses like user@abc123.com will fail.
//    This is stricter than standard email rules — confirm with the team if this is intentional.
export const EMAIL_REGEX = /^[a-zA-Z0-9][a-zA-Z0-9+_-]*(?:\.[a-zA-Z0-9+_-]+)*@(?:[a-zA-Z-](?:[a-zA-Z-]*[a-zA-Z-])?\.)+[a-zA-Z-](?:[a-zA-Z-]*[a-zA-Z-])?$/

// Characters disallowed by our email input rules — blocked at keydown so
// they never enter the field, mirroring the sanitization in handleEmailChange.
export const EMAIL_DISALLOWED_KEYS = [
  '!', '#', '$', '%', '^', '&', '*', '(', ')', '=', '[', ']', '{', '}',
  '\\', '|', ':', "'", '"', ',', '<', '>', '/', '?', '`', '~'
]

// Dealer guest flow — which address the sales rep is activating with.
// AUTO_GENERATED swaps the email field for a throw-away address so a walk-in
// customer without a mailbox can still be activated (see utils/guestEmail).
export const EMAIL_ENTRY_OPTIONS = Object.freeze({
  CUSTOMER: 'customerEmail',
  AUTO_GENERATED: 'autoGeneratedEmail'
})

export const ANALYTICS_EVENT_TYPES = Object.freeze({
  // Use "kprepageview" after new GTM deploy, otherwise use current "koodoappageview"
  PAGE_VIEW: 'kprepageview',    // PAGE_VIEW: 'koodoappageview',  
  CLICK: 'kpreclick',
  POPUP: 'kprepopup',
  PAYMENT_STATUS: 'kprepaymentstatus',
  PURCHASE_SUCCESS: 'kpresuccess'
})

export const ANALYTICS_CONFIG = Object.freeze({
  appName: 'Koodo Prepaid',
  user: '',
  brand: BrandName,
  section: 'portal'
})

export const ANALYTICS_COMMON = Object.freeze({
  NA: 'NA'
})

export const ANALYTICS_JOURNEY_TYPES = Object.freeze({
  NA: 'NA',
  ESIM: 'ESIM',
  PSIM: 'PSIM',
  HSIM: 'HSIM',
  OSIM: 'OSIM',
})

export const ANALYTICS_COOKIE_CONSTANTS = Object.freeze({
  CLICK: 'Click',
  CONSENT_CHOICE: 'Consentchoice',
  CONSENT_UPDATE: 'Consentupdated',
  COOKIE_FOOTER: 'Cookie footer',
  COOKIE_BANNER: 'Cookie consent banner',
  COOKIE_MODAL: 'Cookie Management Centre',
  MANAGE_COOKIES: 'Manage cookies',
  ACCEPT_ALL_COOKIES: 'Accept all cookies',
  CLOSE_MODAL: 'Close cookie modal',
  CLOSE_BANNER: 'Close consent banner',
  CONFIRM_CHOICE: 'Confirm my Choices',
  MANAGE_COOKIES_LINK: 'Manage Cookie Link',
})

export const BOLD_WRAPPER_REGEX = /\{\{([\s\S]*?)\}\}/g

// Plan feature footnote markers, e.g. "1 GB at 4G speed⁴,⁵": literal
// <sup>N</sup> HTML strings and unicode superscript chars (⁰-⁹), plus the
// commas that only join them, all stripped for display-only feature text.
// A single marker (HTML or unicode superscript).
const FEATURE_SUPERSCRIPT = '<sup>[\\s\\S]*?<\\/sup>|[⁰¹²³⁴⁵⁶⁷⁸⁹]'
// Chains repeated ", marker" runs onto the first marker so "⁴,⁵" is
// removed as one match, not left with a dangling comma.
export const FEATURE_SUPERSCRIPT_REGEX = new RegExp(`(?:${FEATURE_SUPERSCRIPT})(?:\\s*,\\s*(?:${FEATURE_SUPERSCRIPT}))*`, 'g')

export const QUOTE_STATE = Object.freeze({
  PHONE_NUMBER_SELECTION: 'Phone Number Selection'
})
